var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 16C0 17.1 0.89 18 1.99 18H16C17.1 18 18 17.1 18 16V6L12 0ZM5 14C4.45 14 4 13.55 4 13C4 12.45 4.45 12 5 12C5.55 12 6 12.45 6 13C6 13.55 5.55 14 5 14ZM5 10C4.45 10 4 9.55 4 9C4 8.45 4.45 8 5 8C5.55 8 6 8.45 6 9C6 9.55 5.55 10 5 10ZM5 6C4.45 6 4 5.55 4 5C4 4.45 4.45 4 5 4C5.55 4 6 4.45 6 5C6 5.55 5.55 6 5 6ZM11 7V1.5L16.5 7H11Z",
    fill: "#9EA5AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalReport);
export default __webpack_public_path__ + "static/media/total_report.9fbda007.svg";
export { ForwardRef as ReactComponent };